<template>
  <div
    class="w-full flex flex-row fixed toolbar justify-around "
    :class="$dm('bg-white', 'dark:bg-slate-950')"
  >
    <button
      class="flex flex-col items-center justify-between px-4 py-3 cursor-pointer relative"
      :style="getCorrectActiveTextColor(this.$route.name === 'home')"
      data-testid="article-message-button"
      @click="goToHome"
    >
      <span class="relative">
        <span v-if="!!unReadConversationsCount" class="unreadBadge" />
        <fluent-icon icon="message-toolbar" size="24" class="mb-1" />
      </span>
      {{ $t('TOOLBAR.MESSAGES') }}
    </button>
    <button
      class="flex flex-col items-center justify-between px-4 py-3 cursor-pointer"
      :style="getCorrectActiveTextColor(this.$route.name.includes('article'))"
      data-testid="article-help-center-button"
      @click="goToHelp"
    >
      <fluent-icon icon="help-toolbar" size="24" class="mb-1" />
      {{ $t('TOOLBAR.HELP_CENTER') }}
    </button>
  </div>
</template>
<script>
import configMixin from '../../mixins/configMixin';
import darkModeMixin from 'widget/mixins/darkModeMixin';
import { mapGetters } from 'vuex';
import FluentIcon from 'shared/components/FluentIcon/Index.vue';

export default {
  components: {
    FluentIcon,
  },
  mixins: [configMixin, darkModeMixin],
  data() {
    return {
      portalId: window.hooryWebChannel.portalId,
    };
  },
  computed: {
    ...mapGetters({
      unReadConversationsCount: 'conversation/getUnReadConversationsCount',
      widgetColor: 'appConfig/getWidgetColor',
    }),
  },
  mounted() {
    if (this.portalId) {
      this.$store.dispatch('helpCenter/fetchPortal', this.portalId);
    }
  },
  methods: {
    goToHome() {
      this.$router.push({ name: 'home' }).catch();
    },
    goToHelp() {
      this.$router
        .push({
          name: 'articles',
          params: { portalId: this.portalId },
        })
        .catch();
    },
    getCorrectActiveTextColor(isActive) {
      const styles = {};
      if (isActive) {
        styles.color = this.$dm(this.widgetColor, '#7d5cef');
        styles.stroke = this.$dm(this.widgetColor, '#7d5cef');
        styles.strokeWidth = 0.2;
        styles.fontWeight = 500;
        styles.opacity = 1;
      } else {
        styles.opacity = 0.75;
      }

      return styles;
    },
  },
};
</script>

<style scoped lang="scss">
@import '~widget/assets/scss/variables';
@import '~widget/assets/scss/mixins';

.toolbar {
  border-top: 1px solid rgba(200, 200, 200, 0.4);
  border-bottom: 1px solid rgba(200, 200, 200, 0.4);
  bottom: 42px;
  font-size: 15px;
  font-weight: 300;
  & .active {
    font-weight: 500;
  }
  & button {
    flex: 1 1 100%;
    &:active,
    &:focus:not(:focus-visible) {
      outline: none;
      border: none;
    }
  }
}
.unreadBadge {
  position: absolute;
  top: 5px;
  right: 2px;
  width: 11px;
  height: 11px;
  background-color: #ff5a5f;
  border-radius: 50%;
  border: 2px solid #fff;
  z-index: 1;
  box-shadow: 0 0 0 1px #fff;
  transform: translate(50%, -50%);
}
</style>
